/**
 * @file Provides help text about obfuscated photos.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  visible: PropTypes.bool,
};

const PhotoViewerHelpText = ({ visible = false }) =>
  visible ? (
    <span className="badge badge-primary photo-viewer-info">
      Press on the photos to reveal the face
    </span>
  ) : null;

PhotoViewerHelpText.propTypes = propTypes;

export default PhotoViewerHelpText;
